<script setup lang="ts">
import type { mastodon } from '#shared/types'

const props = defineProps<{
  tag: mastodon.v1.Tag
}>()
const { tag } = toRefs(props)

const emit = defineEmits(['change'])

async function toggle() {
  const previousState = tag.value.following
  tag.value.following = !tag.value.following
  try {
    const action = previousState ? 'unfollow' : 'follow'
    await $fetch<mastodon.v1.Status>(`/api/tags/${tag.value.id}/${action}`, {
      method: 'POST',
    })
    emit('change')
  }
  catch (error) {
    tag.value.following = previousState
    console.error(error)
  }
}
</script>

<template>
  <button
    :aria-label="tag.following ? $t('tag-unfollow_label', { name: tag.name }) : $t('tag-follow_label', { name: tag.name })"
    @click="toggle()">
    {{ tag.following ? $t('tag-unfollow') : $t('tag-follow') }}
  </button>
</template>
